import React, { useEffect } from 'react';
import { Container , Row, Col } from 'react-bootstrap';
import Catagory from '../../components/catagory/Catagory';
import Video from '../../components/video/Video';
import { useDispatch, useSelector } from 'react-redux'
import {
    getPopularVideos,
    getVideosByCategory,
 } from '../../redux/actions/videos.action';
 import InfiniteScroll from 'react-infinite-scroll-component';
 import SkeletonVideo from '../../components/skeletons/SkeletonVideo'

function HomeScreen() {

    const dispatch = useDispatch();

   useEffect(() => {
      dispatch(getPopularVideos())
   }, [dispatch])

   const { videos , activeCategory, loading } = useSelector(
    state => state.homeVideos
    )

    const fetchData = () => {
        if (activeCategory === 'All') dispatch(getPopularVideos())
        else {
           dispatch(getVideosByCategory(activeCategory))
        }
       
     }

    return (
        <div>
            <Container>
                 <Catagory />
                  <Row>
                  <InfiniteScroll
            dataLength={videos.length}
            next={fetchData}
            hasMore={true}
            loader={
               <div className='spinner-border text-danger d-block mx-auto'></div>
            }
            className='row'>
            {!loading
               ? videos.map(video => (
                    <Col lg={3} md={4} key={video.id}>
                       <Video video={video} key={video.id} />
                    </Col>
                 ))
               : [...Array(20)].map(() => (
                    <Col lg={3} md={4}>
                       <SkeletonVideo />
                    </Col>
                 ))}
         </InfiniteScroll>
                  </Row>
            </Container>
           
        </div>
    )
}

export default HomeScreen;
